// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M17.5247 4.44658L19.6228 3.73145L21.538 9.33301H23V20.9997H1V9.33301H2.65206L14.3468 -0.00878906L17.5247 4.44658ZM15.5485 5.12017L13.945 2.87198L7.84218 7.74689L15.5485 5.12017ZM16.7927 6.80909L9.38792 9.33301H19.4243L18.3869 6.29882L16.7927 6.80909ZM5.28516 14.1638V16.1677H7.28906V14.1638H5.28516Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-pantone-filled')
export default class PantoneFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'pantone-filled',
    }
  }
}
